/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';
import { Button, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

import CategoryFormModal from '../../category/CategoryFormModal';

import './styles.css';

export default function CategoriesCard({ categories, expositionId }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [categoryToEdit, setCategoryToEdit] = useState(null);

  const openCreate = () => {
    setCategoryToEdit(null);
    setModalOpen(true);
  };

  const openEdit = (category) => {
    setCategoryToEdit(category);
    setModalOpen(true);
  };

  const columns = [
    {
      field: 'action',
      headerName: '#',
      sortable: false,
      headerAlign: 'center',
      disableColumnMenu: true,
      renderCell: (params) => (
        <IconButton
          size="small"
          aria-label="Editar"
          onClick={(e) => {
            e.stopPropagation();
            openEdit(params.row);
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      ),
      flex: 1,
    },
    {
      field: 'name',
      headerName: 'Nome',
      headerAlign: 'center',
      flex: 2,
    },
    {
      field: 'updatedAt',
      headerName: 'Última alt.',
      valueFormatter: (params) => moment(params.value).format('L'),
      headerAlign: 'center',
      flex: 2,
    },
  ];

  const dataGridStyles = {
    mt: 2,
    border: 'none',
    '& .MuiDataGrid-columnSeparator': { display: 'none' },
    '& .MuiDataGrid-row': { borderBottom: 'none' },
    '& .MuiDataGrid-rowSeparator': { display: 'none' },
    '& .MuiDataGrid-cell': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& .MuiDataGrid-cell:focus': { outline: 'none' },
  };

  return (
    <div className="categories-card">
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 8,
      }}
      >
        <span className="categories-title">
          <h1>Categorias</h1>
        </span>
        <Button
          variant="contained"
          color="success"
          size="small"
          startIcon={<AddIcon />}
          onClick={openCreate}
        >
          Nova categoria
        </Button>
      </div>

      <DataGrid
        sx={dataGridStyles}
        autoHeight
        rows={categories}
        columns={columns}
        rowsPerPageOptions={[5]}
        pageSize={5}
        disableSelectionOnClick
      />

      <CategoryFormModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        expositionId={expositionId}
        categoryToEdit={categoryToEdit}
        onSaved={() => window.location.reload()}
      />
    </div>
  );
}
